export default "__VITE_ASSET__7452dfa1__"